import React from 'react';
import styled from '@benzinga/themetron';
import { ErrorBoundary } from '@benzinga/core-ui';
import { faComment } from '@fortawesome/pro-light-svg-icons';
import { Button, Icon } from '@benzinga/core-ui';
import { SessionContext } from '@benzinga/session-context';

const CommentsEmbedScript = React.lazy(() =>
  import('@benzinga/comments-ui').then(module => ({ default: module.CommentsEmbedScript })),
);

const CommentsDrawer = React.lazy(() =>
  import('@benzinga/comments-ui').then(module => ({ default: module.CommentsDrawer })),
);
export interface CommentBlockProps {
  attrs?: {
    data?: {
      link?: string;
      type?: 'Article' | 'Quote' | 'Offering';
      label?: string;
      variant?: string;
    };
  };
}

export const CommentBlock: React.FC<CommentBlockProps> = props => {
  const [isCommentsDrawerOpen, setIsCommentsDrawerOpen] = React.useState(false);
  const pageType = props?.attrs?.data?.type;
  const session = React.useContext(SessionContext);

  const handleArticleCommentOpenAnalyticsEvent = () => {
    import('@benzinga/comments-ui').then(module => {
      module.handleCommentsAnalyticsEvent('Offering', 'open-drawer', session);
    });
  };

  const handleOpenCommentsSidebar = () => {
    setIsCommentsDrawerOpen(true);
    pageType && handleArticleCommentOpenAnalyticsEvent();
  };

  const handleCloseCommentsSidebar = () => {
    setIsCommentsDrawerOpen(false);
  };

  return (
    <CommentBlockWrapper className={props.attrs?.data?.variant}>
      <ErrorBoundary name="comment-drawpper-button">
        <div className="w-100 comments-count-button">
          <Button onClick={handleOpenCommentsSidebar} variant={'flat-black'}>
            <Icon className="mr-2" icon={faComment} />
            <span className="comments-count cursor-pointer">{props?.attrs?.data?.label ?? 'Share Your Thoughts!'}</span>
          </Button>
        </div>
        <CommentsDrawer isOpen={isCommentsDrawerOpen} onClose={handleCloseCommentsSidebar} />
        <CommentsEmbedScript
          isInjected={isCommentsDrawerOpen}
          type={pageType}
          url={`https://www.benzinga.com/${props?.attrs?.data?.link ?? ''}`}
        />
      </ErrorBoundary>
    </CommentBlockWrapper>
  );
};

const CommentBlockWrapper = styled.div`
  display: block;
  .comments-count-button {
    button {
      background-color: #002d45;
      width: 100%;
      font-weight: 700;
      &:hover {
        background-color: #fa8418;
        color: white;
      }
    }
    > span {
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }
`;
